import React, { useState, useEffect } from 'react'
import { Checkbox } from '@tecuity/granite-ui'
import { Spinner } from 'components/Loaders/Loaders'
import './CustomCorrespondenceOptions.scss'
import { useDispatch } from 'react-redux'
import * as api from 'requests'
import {
  SET_SETTINGS_LIST,
  SET_OPTIONAL_DATA,
  SET_SETTINGS_PAGE_NUM,
  SET_SETTINGS_FILTER_TEXT,
} from '../../SettingsReducer'
import { useSelector, shallowEqual } from 'react-redux'

const UserDetailOptions = () => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const {
    optionalData,
    settingsList,
    filterText = '',
    pageNum = 0,
  } = useSelector((state) => state.settings, shallowEqual)
  const [includeAllUsers, setIncludeAllUsers] = useState(false)

  useEffect(() => {
    dispatch({ type: SET_SETTINGS_FILTER_TEXT, filterText: '' })
    dispatch({
      type: SET_OPTIONAL_DATA,
      optionalData: { ...optionalData, includeAllUsers: false },
    })
  }, [])

  useEffect(() => {
    queryUsersFilter()
    dispatch({ type: SET_SETTINGS_PAGE_NUM, pageNum: 0 })
  }, [includeAllUsers, filterText])

  useEffect(() => {
    queryUsersAdd()
  }, [pageNum])

  const queryUsersFilter = () => {
    setLoading(true)
    api.GET_SETTINGS_APP_USERS_PAGINATED(
      0,
      includeAllUsers,
      filterText,
      (res) => {
        setLoading(false)
        dispatch({
          type: SET_SETTINGS_LIST,
          settingsList: res
            .filter((user) => user.UserId !== -1)
            .map((user) => {
              return {
                Id: user.UserId,
                Username: `${user.Username} (${user.UserId})`,
              }
            }),
        })
      },
      (err) => {
        setLoading(false)
        console.error(err)
      }
    )
  }

  const queryUsersAdd = () => {
    if (!pageNum) return
    setLoading(true)
    api.GET_SETTINGS_APP_USERS_PAGINATED(
      pageNum,
      includeAllUsers,
      filterText,
      (res) => {
        setLoading(false)
        const temp = [
          ...settingsList,
          ...res
            .filter((user) => user.UserId !== -1)
            .map((user) => {
              return {
                Id: user.UserId,
                Username: `${user.Username} (${user.UserId})`,
              }
            }),
        ]
        dispatch({
          type: SET_SETTINGS_LIST,
          settingsList: temp,
        })
      },
      (err) => {
        setLoading(false)
        console.error(err)
      }
    )
  }

  return (
    <div className="custom-correspondence-options">
      <Checkbox
        label="Include Public Users"
        checked={includeAllUsers}
        onChange={(checked) => {
          setIncludeAllUsers(checked)
          dispatch({
            type: SET_OPTIONAL_DATA,
            optionalData: { ...optionalData, includeAllUsers: checked },
          })
        }}
      />
      {loading ? (
        <div className="inline-spinner">
          <Spinner size="small" themeColor="dark-neutral" />
        </div>
      ) : null}
    </div>
  )
}

export default UserDetailOptions
